import { Table, Skeleton } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState } from 'react';

import { getDebitorBalances } from 'services/tabreport';
import { DEBITORS } from 'events/types';

import { useDashboardContext } from '.';

const Debitors = () => {
  const { columns } = useDashboardContext();

  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);

  const { data, isLoading } = useQuery<any, AxiosError, any>({
    queryKey: [DEBITORS, pageSize, pageIndex],
    queryFn: () => getDebitorBalances(pageSize, pageIndex),
    select: (response) => ({
      data: response.data.data.map((item: any) => ({ ...item, key: item.id })),
      totalRecord: response.data.totalRecord,
    }),
  });

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          rowClassName={(_, i) => (i % 2 === 0 ? 'bg-[#466AFB08]' : 'bg-white')}
          className="h-[calc(100vh-240px)] overflow-y-scroll"
        />
      )}
    </>
  );
};

export default Debitors;
